function getElementNormalizedAttribute(element, attributeName) {
  const attributeValue = element?.getAttribute(attributeName);
  return attributeValue?.length ? attributeValue : void 0;
}

export { getElementNormalizedAttribute };
